export const BASE_URL = 'https://neverland-world-test.herokuapp.com/';

export const USER_DATA = 'UserData';
